import { defineStore } from 'pinia';
import axios from 'axios';

// Blog posts admin store (About Us + Blog CMS). Mirrors usePaymentRequestStore
// conventions: server-side paginated + filterable.
export const useBlogStore = defineStore('blogPosts', {
    state: () => ({
        posts: [],
        pagination: null,   // Laravel paginator meta
        loading: false,
        saving: false,
        filters: { category_id: '', is_published: '', is_featured: '', search: '', per_page: 20 },
    }),

    actions: {
        async fetchPosts(page = 1) {
            this.loading = true;
            try {
                const params = { page, per_page: this.filters.per_page };
                if (this.filters.category_id) params.category_id = this.filters.category_id;
                if (this.filters.is_published !== '') params.is_published = this.filters.is_published;
                if (this.filters.is_featured !== '') params.is_featured = this.filters.is_featured;
                if (this.filters.search) params.search = this.filters.search;
                const { data } = await axios.get('/admin/blog-posts', { params });
                this.posts = data.data.data ?? [];
                this.pagination = data.data;
            } finally {
                this.loading = false;
            }
        },

        async fetchPost(id) {
            const { data } = await axios.get(`/admin/blog-posts/${id}`);
            return data.data;
        },

        async createPost(payload) {
            this.saving = true;
            try {
                const { data } = await axios.post('/admin/blog-posts', payload);
                return data.data;
            } finally {
                this.saving = false;
            }
        },

        async updatePost(id, payload) {
            this.saving = true;
            try {
                // POST fallback route accepts multipart updates (Laravel can't parse
                // multipart on PUT); backend maps both to BlogPostController@update.
                const { data } = await axios.post(`/admin/blog-posts/${id}`, payload);
                return data.data;
            } finally {
                this.saving = false;
            }
        },

        async deletePost(id) {
            await axios.delete(`/admin/blog-posts/${id}`);
            this.posts = this.posts.filter(p => p.id !== id);
        },

        async togglePublish(id) {
            const { data } = await axios.patch(`/admin/blog-posts/${id}/toggle-publish`);
            this.replaceLocal(data.data);
            return data.data;
        },

        async toggleFeatured(id) {
            const { data } = await axios.patch(`/admin/blog-posts/${id}/toggle-featured`);
            this.replaceLocal(data.data);
            return data.data;
        },

        replaceLocal(post) {
            const idx = this.posts.findIndex(p => p.id === post.id);
            if (idx !== -1) this.posts[idx] = post;
        },
    },
});
